<template>
  <div class="menu-phone-container">
    <el-button text class="text-second-title menu-phone-item margin-top-60" @click="selectButton(AppConfig.route_home)">首页</el-button>
    <el-divider></el-divider>
    <el-button text class="text-second-title menu-phone-item" @click="selectButton(AppConfig.route_cpCredit)">企业信用维护</el-button>
    <el-divider></el-divider>
    <el-button text class="text-second-title menu-phone-item" @click="selectButton(AppConfig.route_about)">关于我们
    </el-button>
    <el-divider></el-divider>
    <el-button text class="text-second-title menu-phone-item" @click="onPhoneClick()">电话：13167540356</el-button>
    <el-divider></el-divider>
    <el-button text class="text-second-title menu-phone-item" @click="onQrCodeClick()">微信扫码联系</el-button>
    <el-divider></el-divider>
  </div>
</template>

<script lang="ts" setup>
import router from "@/router";
import {AppConfig} from "@/config";
import {isShowMenuPhone, isShowQrCodeDialog} from "@/views/data/CommonData";

const selectButton = (button: string) => {
  router.push(button)
  isShowMenuPhone.value = !isShowMenuPhone.value;
}
const onQrCodeClick = () => {
  isShowQrCodeDialog.value = true
}
const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}
</script>

<style scoped>
.menu-phone-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: #ffffff;
}

.menu-phone-item {
  height: 50px;
  width: 100%;
  text-align: start;
}

.header-menu-img-phone {
  width: 30px;
  height: auto;
}

.text-second-title {
  font-size: 13px;
}

.el-button {
  justify-content: start;
}

.el-divider {
  margin: 0px;
  border-color: #eeeeee;
}
</style>
